export const maskEmail = (email) => {
  if (!email || typeof email !== 'string') {
    return '';
  }
  const atIndex = email.indexOf('@');
  if (atIndex <= 0) {
    return email;
  }
  const local = email.slice(0, atIndex);
  const domain = email.slice(atIndex);
  if (local.length <= 1) {
    return `*${domain}`;
  }
  return `${local[0]}***${domain}`;
};
